import React from 'react'
import { useRouter } from 'next/router'
import Link from 'next/link'
import PaymentMethods from 'src/components/settings/payments/PaymentMethods'
import PaymentMethodsV2 from 'src/components/settings/payments/PaymentMethodsV2'
import PaymentGateways from 'src/components/settings/payments/PaymentGateways'
import PaymentAdditionalCharges from 'src/components/settings/payments/PaymentAdditionalCharges'
import { ArrowRight } from 'react-feather'
import { useUser } from 'src/lib/contexts/UserContext'
import { useLocale } from 'src/lib/hooks/useLocal'
import { useSubscriptionPermissions } from 'src/lib/access-permission-hooks/useSubscriptionPermissions'

const PaymentsSettings: React.FC<{}> = ({}) => {
  const { t } = useLocale()
  const router = useRouter()
  const { s_id } = router.query
  const { user } = useUser()
  const { canViewSubscriptions } = useSubscriptionPermissions()

  //If payment gate ID is present, render the payment config page
  if (Boolean(s_id))
    return (
      <>
        <PaymentGateways />
      </>
    )

  return (
    <>
      <div className='flex flex-col w-full h-full gap-4 pb-20'>
        <section
          className={`p-4 bg-white border border-[#F0F0F0] rounded-lg flex flex-col gap-4 ${
            user?.isDemoUser ? 'opacity-50 pointer-events-none' : ''
          }`}
        >
          <div className='flex flex-col '>
            <h2 className='font-medium text-carbon'>Payment gateways</h2>
            <p className='text-xs text-gray-dark'>Bring your own PG!</p>
            {user?.isDemoUser && <p className='text-xs text-red-500'>Not available in Demo Mode</p>}
          </div>
          <PaymentGateways />
        </section>

        {/* Todo: shradhan remove this once paymentsv2 is out */}
        {/* <section className='p-4 bg-white border border-[#F0F0F0] rounded-lg flex flex-col gap-4'>
          <div className='flex flex-col '>
            <h2 className='font-medium text-carbon'>Redirect payment methods</h2>
            <p className='text-xs text-gray-dark'>Choose PGs for specific payment methods</p>
          </div>
          <PaymentMethods isMutable={false} />
        </section> */}

        <section className='p-4 bg-white border border-[#F0F0F0] rounded-lg flex flex-col gap-4'>
          <div className='flex flex-col '>
            <h2 className='font-medium text-carbon'>Redirect payment methods</h2>
            <p className='text-xs text-gray-dark'>Choose PGs for specific payment methods</p>
          </div>
          <PaymentMethodsV2 />
          {canViewSubscriptions && (
            <>
              <h2 className='font-medium text-carbon'>{t('payments_tab.subscription')}</h2>
              <PaymentMethodsV2 modeType='SUBSCRIPTION' />
            </>
          )}
        </section>

        <PaymentAdditionalCharges />

        <section className='p-4 bg-white border border-[#F0F0F0] rounded-lg flex flex-col gap-4'>
          <div className='flex flex-col '>
            <h2 className='font-medium text-carbon'>Edit payment method tiles</h2>
            <p className='text-xs text-gray-dark'>Customise descriptions, re-order, and toggle visibility</p>
          </div>

          <Link href={'/style/payment'} passHref>
            <div className='flex flex-row items-center gap-1 text-sm font-semibold underline text-coal-dark decoration-gray-light underline-offset-2'>
              <p>Go to Customise UI</p>
              <ArrowRight size={16} />
            </div>
          </Link>
        </section>
      </div>
    </>
  )
}

export default PaymentsSettings
